import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { SECTION_ICONS } from "@/constants/section-icons.constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'SectionIcon',
  props: {
  size: {
    required: false,
    type: Number,
    default: 24
  },
  iconId: {
    type: [Number, String],
    required: true
  },
  name: {
    type: String,
    required: false
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_SVGIcon = _resolveComponent("SVGIcon")!

  return (_openBlock(), _createBlock(_component_SVGIcon, {
    path: _unref(SECTION_ICONS)[`icon${__props.iconId}`],
    size: __props.size,
    title: __props.name
  }, null, 8, ["path", "size", "title"]))
}
}

})